import { post, get } from '../utils/fetch';

// 新闻的API
export default class NewsService {
    // 新闻列表
    static fetchNewsList(params) {
        return get('/api/v1/dynamic/pageQuery', params)
    }
    // 新闻详情
    static fetchNewsDetail(params) {
        return get('/api/v1/dynamic/get', params)
    }
}




// WEBPACK FOOTER //
// ./src/api/newsService.js